// covered-by: frontends/carrie/src/components/ask-puntt-review/__tests__/artworkPreviewSource.test.ts
import { normalizeThumbnailUrl } from "./resolveReviewListCardThumbnail";

const PDF_NAME = /\.pdf$/i;

type PreviewFile = {
  source?: string | null;
  name?: string | null;
  thumbnailUrl?: string | null;
};

/**
 * The artwork PDF to rasterize when the review has no image thumbnail.
 *
 * A PDF `source` cannot be an `<img src>`. Callers rasterize page 1 instead,
 * and skip any file that already has its own thumbnail.
 */
export function artworkPreviewSource(
  files: readonly PreviewFile[] | null | undefined,
): string | undefined {
  for (const file of files ?? []) {
    if (normalizeThumbnailUrl(file.thumbnailUrl)) continue;
    const source = file.source?.trim();
    if (!source) continue;
    const name = file.name?.trim() ?? "";
    // split always yields a first segment, including "" for an empty source.
    const path = source.split("?")[0];
    if (PDF_NAME.test(name) || PDF_NAME.test(path)) return source;
  }
  return undefined;
}
